module.exports = __webpack_public_path__ + "media/img/logo-ebaeb9cd13f88d70d5c9d5e340b0a920.png";